import { useEffect, useState } from 'react';

const MOCK = import.meta.env?.VITE_MOCK === 'true';

// SPauth init (appId chain + useJWTforXHR) runs at module load in
// src/index.jsx so the XHR/fetch JWT patch is in place before any
// component fetches. This container only handles the login() promise
// and gates children on the resulting user.
//
// Local dev escape hatch: VITE_MOCK=true skips the SPauth flow entirely
// and immediately renders with a fake user so we can iterate on layout
// without a Cox VPN / SSO callback whitelist.
export function SpauthContainer({ renderWithUser }) {
  const [user, setUser] = useState(MOCK ? { username: 'localdev', name: 'Local Dev' } : null);

  useEffect(() => {
    if (MOCK) return;
    window.SPAUTH.login().then((loggedInUser) => {
      setUser(loggedInUser);
    });
  }, []);

  if (!user) return null;
  return renderWithUser(user);
}
